import styled, { Toast, STANDARD_EASING } from "livemap-ui";
import { useToasts } from "../contexts/toast";

export function Toasts() {
  const toasts = useToasts();

  return (
    <ToastContainer>
      {toasts.map(({ id, text, ...toast }) => (
        <Toast key={id} {...toast}>
          {text}
        </Toast>
      ))}
    </ToastContainer>
  );
}

const ToastContainer = styled.div`
  position: fixed;
  padding: 24px;
  right: 0;
  top: 0;

  @media screen and (max-width: 400px) {
    top: auto;
    bottom: 0;
  }

  > * {
    @keyframes toast-fly-in {
      from {
        opacity: 0;
        transform: scale(0) translateX(120%);
      }
      to {
        opacity: 1;
        transform: scale(1) translateX(0%);
      }
    }

    animation: toast-fly-in 340ms ${STANDARD_EASING};
    animation-fill-mode: forwards;
  }
`;
